import React from 'react';
import { NumberInputRecord } from 'types/dynamic-forms/records/NumberInputRecord';
import usePropertyPath from '../hooks/usePropertyPath';
import useProperty from '../hooks/useProperty';
import { useDocumentStore } from '../hooks/useDocumentStore';
import WizardNumberInputControlled from 'components/v2/epd-wizard-inputs/WizardNumberInputControlled';

const NumberInputRenderer: React.FC<NumberInputRecord> = ({
  propertyId,
  label,
  tooltip,
  maxFractionDigits,
  setValuesOnChange,
}) => {
  const store = useDocumentStore();
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<number | null>(propertyPath);
  if (!isVisible) {
    return null;
  }

  const handleChange = (val: number | null) => {
    setValue(val);

    if (!setValuesOnChange) {
      return;
    }
    // Sync derived properties, optionally only while another property holds a given value.
    for (const rule of setValuesOnChange) {
      if (rule.onlyWhenPropertyId !== undefined && store.getValue([rule.onlyWhenPropertyId]) !== rule.onlyWhenEquals) {
        continue;
      }
      store.setValue([rule.propertyId], rule.fromSelf ? val : rule.value);
    }
  };

  return (
    <WizardNumberInputControlled
      label={label}
      tooltip={tooltip}
      name={propertyId}
      value={value}
      onChange={(_, val) => handleChange(val)}
      error={errorMessage}
      disabled={isDisabled}
      maxFractionDigits={maxFractionDigits}
    />
  );
};

export default NumberInputRenderer;
